import React from 'react'

// import LogoLuna from '../../../Assets/Frame 78.svg'

import './index.css'

function Logo() {
    return (
        <div className='main-logoluna'>
            {/* <img src={LogoLuna} alt="LogoLuna" /> */}
        </div>
    )
}

export default Logo